import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { getTagsForDealership, showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';
import CustomModal from '../shared/CustomModal';
import CustomPopupText from '../shared/CustomPopupText';
import CustomTextField from '../shared/CustomTextField';

const AddNewTag = (props) => {
  const dispatch = useDispatch();
  const tagList = useSelector((state) => state.getTagsForDealership.dealershipTags) || [];
  const [tagTitle, setTagTitle] = useState('');

  const validateForm = () => {
    const errors = [];
    let formIsValid = true;
    if (!tagTitle) {
      formIsValid = false;
      errors.push('Please enter tag title.');
    }
    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return formIsValid;
  };

  const submit = async () => {
    const check = validateForm();
    if (check) {
      dispatch(showProgress(true));
      const data = JSON.stringify({
        title: tagTitle,
        type: props.type,
      });
      await service
        .post(apiEndpoints.DEALER_TAG_ADD, data)
        .then((response) => {
          tagList.push(response);
          dispatch(getTagsForDealership(tagList));
          dispatch(showProgress(false));
          notifySuccess('Completed Successfully');
          closePopup();
        })
        .catch((error) => {
          dispatch(showProgress(false));
          ErrorToast(error);
          closePopup();
        });
    }
  };

  const handleTagTitleChange = (e) => {
    setTagTitle(e.target.value);
  };

  const closePopup = () => {
    setTagTitle('');
    props.close();
  };

  const modalContent = (
    <Grid container direction="column" justifyContent="space-between" alignItems="flex-start">
      <Grid item>
        <CustomPopupText text="Dealership Tag" required />
      </Grid>
      <Grid item style={{ width: '100%' }}>
        <CustomTextField
          name="tagTitle"
          rows={1}
          placeholder="Enter Dealership Tag"
          id="tagTitleId"
          height="64px"
          handleChange={handleTagTitleChange}
          value={tagTitle}
          width="100%"
        />
      </Grid>
    </Grid>
  );

  return (
    <CustomModal
      isOpen={props.open}
      handleClose={closePopup}
      title="Add New Tag"
      content={modalContent}
      onSave={submit}
      saveLabel="Save"
      cancelLabel="Cancel"
      height="324px"
      width="375px"
    />
  );
};

export default AddNewTag;
